module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-72.a7e00bc9.svg";